import './ui.css';

/**
 * Botón base de la librería.
 *
 * <Button>Guardar</Button>
 * <Button variant="secondary">Cancelar</Button>
 * <Button variant="danger" size="sm" onClick={handleDelete}>Eliminar</Button>
 */
export default function Button({
  children,
  variant = 'primary', // 'primary' | 'secondary' | 'danger' | 'ghost' | 'success'
  size,                // undefined | 'sm'
  disabled = false,
  type = 'button',
  onClick,
  ...rest
}) {
  const cls = ['ui-btn', `ui-btn--${variant}`, size === 'sm' ? 'ui-btn--sm' : '']
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={cls} disabled={disabled} onClick={onClick} {...rest}>
      {children}
    </button>
  );
}
